import { useCallback, useEffect, useState } from 'react';

/** Tiny hash router — no dependency, and it survives an offline reload. */

export interface Route {
  path: string;
  params: URLSearchParams;
}

function read(): Route {
  const raw = window.location.hash.replace(/^#/, '') || '/';
  const [path, query = ''] = raw.split('?');
  return { path: path || '/', params: new URLSearchParams(query) };
}

export function navigate(path: string, params?: Record<string, string | undefined>): void {
  const query = new URLSearchParams();
  for (const [k, v] of Object.entries(params ?? {})) if (v !== undefined) query.set(k, v);
  const q = query.toString();
  window.location.hash = q ? `${path}?${q}` : path;
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(read);

  useEffect(() => {
    const onChange = () => setRoute(read());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return route;
}

export function useNavigate(): typeof navigate {
  return useCallback(navigate, []);
}
